import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { default as MUIAppBar } from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/icons/Menu'
import { AppBarStore } from '../../store/app-bar/app-bar-store'
import { APP_BAR_STORE, NAVIGATION_MENU_STORE } from '../../store/stores'
import { NavigationMenuStore } from '../../store/navigation-menu/navigation-menu-store'
import styles from './app-bar.scss'

@inject(APP_BAR_STORE)
@inject(NAVIGATION_MENU_STORE)
@observer
export class AppBar extends Component {

    static propTypes = {
        appBarStore: PropTypes.instanceOf(AppBarStore),
        navigationMenuStore: PropTypes.instanceOf(NavigationMenuStore),
    }

    render() {
        const { title } = this.props.appBarStore
        const { open: menuOpen, setOpen } = this.props.navigationMenuStore

        return (
            <MUIAppBar
                position="static"
                className={styles.appBar}
            >
                <Toolbar>
                    <IconButton onClick={() => setOpen(!menuOpen)}>
                        <Menu className={styles.icon}/>
                    </IconButton>
                    <p className={styles.title}>{title}</p>
                </Toolbar>
            </MUIAppBar>
        )
    }
}
